// extracted by mini-css-extract-plugin
export var cartText = "CartFooter_cartText__RzNb8";
export var container = "CartFooter_container__ybm+z";